import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
	selector: 'cv-pipeline-dialog',
	templateUrl: 'pipeline-dialog.component.html',
	styleUrls: ['pipeline-dialog.component.scss']
})
export class PipelineDialogComponent implements OnInit {
	public content: any;
	constructor(public dialogConfig: DynamicDialogConfig) {}

	ngOnInit() {
		if (this.dialogConfig.data.content) {
			this.content = this.dialogConfig.data.content;
		}
	}
}
